// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610090806/js/" + chunkId + "." + {"44":"4f9f4746","225":"844f7b24","481":"61eb152e","486":"762615c0","770":"dba68a31"}[chunkId] + ".0.7206402949539229.chunk.js";
};